<mat-card class="dm__card">

  <p8-layout-settings-header [titlePath]="['Gestion des formulaires']"></p8-layout-settings-header>
  <mat-card-content>
    <div *ngIf="isAdmin" fxLayoutAlign="end"><mat-card-subtitle>
      <mat-checkbox labelPosition="after" [(ngModel)]="adminView" data-cy="chkbx-accueil-admin-view">
        Vue administrateur
      </mat-checkbox>
    </mat-card-subtitle>
    </div>
    <mat-tab-group [(selectedIndex)]="selectedTabIndex" mat-stretch-tabs="false" mat-align-tabs="start">
      <mat-tab label="Formulaires">
        <app-formulaires-liste *ngIf="selectedTabIndex === 0" [adminView]="adminView"></app-formulaires-liste>
      </mat-tab>
      <mat-tab label="Gestion des liens formulaires">
        <app-url-list *ngIf="selectedTabIndex === 1" [adminView]="adminView"></app-url-list>
      </mat-tab>
      <mat-tab label="Formulaires archivés">
        <app-formulaires-archived *ngIf="selectedTabIndex === 2" [adminView]="adminView"></app-formulaires-archived>
      </mat-tab>
      <mat-tab label="categories formulaires" *ngIf="isSuperviseur">
        <app-form-categorie *ngIf="selectedTabIndex === 3"></app-form-categorie>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>
